import { events } from "@planzone/events";
import { Boundaries } from "@planzone/core";
import { setRequestStateToPending } from "../../utils/setRequestStateToPending";
import { setRequestStateToSuccess } from "../../utils/setRequestStateToSuccess";
import { setRequestStateToFailure } from "../../utils/setRequestStateToFailure";
import { createStateReducer } from "../../utils/createStateReducer";
import { resetState } from "../../utils/resetState";
import { State, Selector } from "./types";
import { createSelector } from "./selector";

const initialState: State = [];

function handleRequest(
  state: State,
  { project, portfolio }: Boundaries["assignProjectToPortfolio"]["request"],
): State {
  const index = state.findIndex(
    (req) =>
      req.project.uuid === project.uuid &&
      req.portfolio.uuid === portfolio.uuid,
  );

  return index !== -1
    ? [
        ...state.slice(0, index),
        { project, portfolio, request: setRequestStateToPending() },
        ...state.slice(index + 1),
      ]
    : [...state, { project, portfolio, request: setRequestStateToPending() }];
}

function handleSuccess(
  state: State,
  { project, portfolio }: Boundaries["assignProjectToPortfolio"]["success"],
): State {
  const index = state.findIndex(
    (req) =>
      req.project.uuid === project.uuid &&
      req.portfolio.uuid === portfolio.uuid,
  );

  return index !== -1
    ? [
        ...state.slice(0, index),
        { project, portfolio, request: setRequestStateToSuccess() },
        ...state.slice(index + 1),
      ]
    : [...state, { project, portfolio, request: setRequestStateToSuccess() }];
}

function handleFailure(
  state: State,
  { project, portfolio }: Boundaries["assignProjectToPortfolio"]["failure"],
): State {
  const index = state.findIndex(
    (req) =>
      req.project.uuid === project.uuid &&
      req.portfolio.uuid === portfolio.uuid,
  );

  return index !== -1
    ? [
        ...state.slice(0, index),
        { project, portfolio, request: setRequestStateToFailure() },
        ...state.slice(index + 1),
      ]
    : [...state, { project, portfolio, request: setRequestStateToFailure() }];
}

const reduceState = resetState(
  initialState,
  createStateReducer(initialState, {
    [events.assignProjectToPortfolioRequested]: handleRequest,
    [events.assignProjectToPortfolioSucceeded]: handleSuccess,
    [events.assignProjectToPortfolioFailed]: handleFailure,
  }),
  [events.changePlanzoneSucceeded],
);

export type { State, Selector };

export { reduceState, initialState, createSelector };
